import React, { FC } from 'react'

import styles from './ArrowRightIcon.module.scss'

type ArrowRightIconProps = {
  color: 'black' | 'white'
  strokeWidth?: number
  className?: string
  width?: string
  height?: string
}

const ArrowRightIcon: FC<ArrowRightIconProps> = ({
  color,
  strokeWidth,
  className,
  width = '21.036',
  height = '48.388',
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21.036 48.388"
    >
      <g
        id="Group_1042"
        data-name="Group 1042"
        transform="translate(0.384 0.321)"
      >
        <path
          id="Path_56"
          data-name="Path 56"
          d="M0,0,20,23.919,0,47.746"
          transform="translate(0)"
          fill="none"
          stroke={color.toString()}
          strokeWidth={strokeWidth ? `${strokeWidth}px` : '1px'}
        />
      </g>
    </svg>
  )
}

export default ArrowRightIcon
